export default __webpack_public_path__ + "static/media/Img4.a1327a4b.jpg";